export default from './SignUp';



// WEBPACK FOOTER //
// ./src/components/SignUp/index.js